<template>
  <div class="form-container">
    <iframe
      id="JotFormIFrame-260938288812872"
      src="https://form.jotform.com/260938288812872"
      frameborder="0"
      allow="geolocation; microphone; camera; fullscreen; payment"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "JotformComponent",
  mounted() {
    const script = document.createElement('script');
    script.src = "https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js";
    script.onload = () => {
      window.jotformEmbedHandler(
        "iframe[id='JotFormIFrame-260938288812872']",
        "https://form.jotform.com/"
      );
    };
    document.body.appendChild(script);
  }
};
</script>

<style scoped>
.form-container {
  max-width: 900px;
  margin: auto;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

iframe {
  width: 100%;
  min-height: 600px;
  border: none;
}
</style>